import {
  IconWrapper,
  IStyles,
  PrimaryButton,
  pxToRem,
  pxTovW,
  SelectMenu,
} from '@geneo2-web/shared-ui';
import { Box, Button, Modal, Typography, Zoom } from '@mui/material';
import { BestAttemptCheck } from './BestAttemptCheck';
import { IOptionList } from './CAEndedHwLeftPanel';

const styles: IStyles = {
  root: {},

  orPartition: {
    margin: 'auto',
    width: { xs: '100%', md: '100%', lg: '100%' },
    mt: { xs: pxToRem(35), md: pxTovW(70) },
    position: 'relative',
    border: { xs: '1px solid #E8E8E8', md: `${pxTovW(2)} solid #E8E8E8` },
  },
  orBox: {
    margin: 'auto',
    width: 'max-content',
    borderRadius: '50%',
    p: { xs: pxToRem(8), md: pxTovW(8) },
    backgroundColor: '#E8E8E8',
    position: 'absolute',
    left: '45%',
    top: { xs: pxToRem(-15), md: pxTovW(-25), lg: pxTovW(-17) },
  },

  confirmSelectionButton: {
    mt: { xs: pxToRem(50), md: pxTovW(100) },
    margin: 'auto',
    display: 'flex',
  },
};

interface IProps {
  open: boolean;
  handleClose: () => void;
  closeIcon?: boolean;
  attemptList: IOptionList[];
  selectedAttempt: string;
  onChangeSelectMenu: (value: string) => void;
  bestAttemptChecked: boolean;
  onChangeCheckbox: () => void;
  confirmSelectionCTA: () => void;
}
export const SelectAttemptForReportPopup = (props: IProps) => {
  const {
    open,
    handleClose,
    closeIcon,
    attemptList,
    selectedAttempt,
    onChangeSelectMenu,
    bestAttemptChecked,
    onChangeCheckbox,
    confirmSelectionCTA,
  } = props;

  return (
    <Modal open={open} onClose={handleClose}>
      <Zoom in={open} mountOnEnter unmountOnExit timeout={700}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'center',
            alignItems: { xs: 'center', md: 'flex-start' },
            height: '100vh',
            width: { xs: '100vw', md: '100vw' },
            mt: { xs: '18%', md: '10%' },
            gap: { xs: pxToRem(10), md: pxTovW(20) },
            boxSizing: 'border-box',
          }}
        >
          <Box
            sx={{
              width: { xs: '95%', md: 'unset' },
              paddingY: { xs: pxToRem(25), md: pxTovW(50) },
              paddingX: { xs: pxToRem(25), md: pxTovW(85) },
              backgroundColor: 'common.white',
              borderRadius: { xs: pxToRem(10), md: pxTovW(20) },
              // mr: { xs: pxToRem(10), md: pxTovW(20) },
              boxSizing: 'border-box',
            }}
          >
            <Typography variant="h3" textAlign="center">
              Choose the Attempt that You Want to Generate the Report For
            </Typography>
            <SelectMenu
              placeholder="select"
              value={bestAttemptChecked ? 'Best Attempt' : selectedAttempt}
              onChange={(value: string) => onChangeSelectMenu(value)}
              disabled={bestAttemptChecked}
              optionList={attemptList}
              rootStyles={{
                width: { xs: '100%', md: '100%', lg: '100%' },
                height: { xs: pxToRem(55), md: pxTovW(75), lg: pxTovW(65) },
                '& .Mui-disabled': { backgroundColor: '#F5FAFF' },
                mt: { xs: pxToRem(10), md: pxTovW(20) },
              }}
              selectedBold
              menuItemStyles={{
                padding: { xs: pxToRem(10), md: pxTovW(20), lg: pxTovW(20) },
              }}
            />

            <Box sx={styles.orPartition}>
              <Box sx={styles.orBox}>
                <Typography variant={'h4'} fontWeight={'medium'}>
                  OR
                </Typography>
              </Box>
            </Box>

            <BestAttemptCheck
              checkedState={bestAttemptChecked}
              onChangeCheckbox={onChangeCheckbox}
              labelText=" Choose the the Best Attempt"
              rootStyles={{ mt: { xs: pxToRem(35), md: pxTovW(70) } }}
            />

            <PrimaryButton
              onClick={confirmSelectionCTA}
              sx={styles.confirmSelectionButton}
            >
              <Typography
                variant="h2"
                color="white"
                sx={{ fontSize: { xs: pxToRem(16), md: pxTovW(26) } }}
              >
                CONFIRM SELECTION
              </Typography>
            </PrimaryButton>
          </Box>

          {closeIcon && (
            <Button onClick={handleClose} sx={{ p: '0px' }}>
              <IconWrapper
                name="close-yellow"
                size="md"
                parentFolder="icons"
                type="png"
                customSx={{
                  width: { xs: pxToRem(33), md: pxTovW(54) },
                  height: { xs: pxToRem(33), md: pxTovW(54) },
                }}
              />
            </Button>
          )}
        </Box>
      </Zoom>
    </Modal>
  );
};
